import type { SortOption } from 'src/redux/productsQuery/types/SortOption';
import type { BrowseDataAPISortingOption } from 'src/services/browse-data-api/types/BrowseDataAPISortingOption';

export const adaptBrowseSortOptions = (
  browseSortingOptions: BrowseDataAPISortingOption[],
): SortOption[] => {
  return browseSortingOptions.map((option) => ({
    active: option.active,
    id: option.id,
    title: option.title,
  }));
};
